/** Static annexure templates served from `IMS-Frontend/public/vms/templates/`. */
export const ANNEXURE_15B_SELF_CERTIFICATION_TEMPLATE = {
  href: '/vms/templates/Annexure-15B-Self-Certification-Template.docx',
  fileName: 'Annexure-15B-Self-Certification-Template.docx',
} as const;
